import React from 'react';
export const FounderStory = () => {
  return <div className="w-full bg-gray-50 py-12 px-4 md:px-8" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <h2 className="text-3xl font-bold mb-8" data-id="element-63">The Dorm Room Beginning</h2>
        <div className="flex flex-col md:flex-row gap-8 mb-8 items-center" data-id="element-64">
          <div className="md:w-1/2" data-id="element-65">
            <p className="text-lg leading-relaxed mb-4" data-id="element-66">
              This brand was never supposed to be a brand. It started in my
              college dorm room in Texas — late nights, too many finals, and a
              closet full of clothes that didn't match the confidence I was
              trying to carry.
            </p>
            <p className="text-lg leading-relaxed" data-id="element-67">
              I wanted jewelry that looked expensive, felt heavy, and made
              people turn their heads… but without draining my entire savings
              account.
            </p>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-68">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7KmdKxMvHx3HGAoGxU9uTm/20250705_2025_FRZN_Shirt_Adjustment_remix_01jzehtnzqe30a78bwdrxsj090.png" alt="FRZN Founder with branded jewelry pouch" className="w-full max-w-xs rounded-md shadow-md" data-id="element-69" />
          </div>
        </div>
        <div className="border-l-4 border-black pl-6 py-2 mb-8" data-id="element-70">
          <h3 className="text-2xl font-bold mb-4" data-id="element-71">The First Plug</h3>
          <p className="text-lg leading-relaxed" data-id="element-72">
            I started looking for pieces I'd actually want to wear. Not the weak
            chains you find at the mall kiosk — I'm talking statement-level,
            club-ready, "who is that?" type jewelry. After months of hunting, I
            made some connections with jewelers in Italy who could ship directly
            to me in Texas.
          </p>
          <p className="text-lg leading-relaxed mt-4" data-id="element-73">
            When that first box came in, me and my guys were lit. We wore them
            out that weekend, and people started asking where we got them.
            That's when I realized — maybe this could be something bigger.
          </p>
        </div>
      </div>
    </div>;
};